import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/app.vue")),
  blinkproject: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/blinkproject.vue")),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue")),
  home: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/home.vue")),
  landing: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/landing.vue")),
  project: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/project.vue"))
}